var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "col-12 col-lg-6",
    },
    [
      _c(
        "div",
        {
          staticClass: "card shadow-sm",
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card-body py-3",
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "w-100 h-200",
                },
                _vm._l(_vm.items, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: item.index,
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex border-bottom align-items-center p-1",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "flex-width text-center text-sm",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(index + 1) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "flex-width text-center text-sm",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.masked_name) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-width text-center text-sm text-monospace",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.showShootDigit(item.digit)) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "flex-width text-center text-sm",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.created_at) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "card-header bg-primary py-3 my-0",
      },
      [
        _c(
          "h2",
          {
            staticClass: "text-lg py-0 my-0 text-center text-white",
          },
          [_vm._v("รายการเพิ่มเลข 30 อันดับล่าสุด")]
        ),
      ]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex border-bottom",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-center text-lg",
          },
          [_vm._v("ลำดับ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex-width text-center text-lg",
          },
          [_vm._v("ชื่อ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex-width text-center text-lg",
          },
          [_vm._v("เลข")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex-width text-center text-lg",
          },
          [_vm._v("เวลาส่ง")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }